import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
const StatelessBackgroundImage = ({ fit = 'grow', imageUrl, alt, children, opacity, alignItems, }) => {
    // console.log('imageUrl', imageUrl);
    if (!imageUrl) {
        return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        _jsx(_Fragment, { children: children }));
    }
    switch (fit) {
        case 'fit':
            return (_jsx(Box, { sx: {
                    // border: '1px solid red',
                    backgroundImage: `url(${imageUrl})`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                }, children: children }));
        case 'grow':
            return (_jsxs(Box, { sx: {
                    display: 'grid',
                    gridTemplate: '1fr / 1fr',
                    placeItems: 'center',
                    alignItems: { alignItems },
                }, children: [_jsx("img", { src: imageUrl, alt: alt, style: {
                            gridColumn: 1 / 1,
                            gridRow: 1 / 1,
                            width: '100%',
                            height: 'auto',
                            zIndex: 1,
                            opacity: `${opacity}`,
                        } }), _jsx(Box, { sx: {
                            gridColumn: 1 / 1,
                            gridRow: 1 / 1,
                            width: '100%',
                            zIndex: 2,
                        }, children: children })] }));
        case 'tile':
            return (_jsx(Box, { sx: {
                    // border: '1px solid red',
                    backgroundImage: `url(${imageUrl})`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'repeat',
                }, children: children }));
        default:
            return (_jsxs(Box, { sx: {
                    position: 'relative',
                    zIndex: 1,
                }, children: [_jsx(Box, { sx: {
                            position: 'absolute',
                            // border: '8px solid blue',
                            // backgroundImage: `linear-gradient(rgba(255,255,255,${opacity}),
                            // rgba(255,255,255,${opacity})), url(${imageUrl})`,
                            backgroundImage: `url(${imageUrl})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center center',
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0,
                            opacity,
                            width: 1,
                            height: 1,
                            zIndex: -1,
                        } }), children] }));
    }
};
export default StatelessBackgroundImage;
//# sourceMappingURL=StatelessBackgroundImage.js.map